import { render, staticRenderFns } from "./MelonOnlineClass.vue?vue&type=template&id=00515eab&"
import script from "./MelonOnlineClass.vue?vue&type=script&lang=js&"
export * from "./MelonOnlineClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports